export const VIEWER = 'viewer';
export const EDITOR = 'editor';
export const ADMIN = 'admin';
export const CATALOG_VIEW = 'catalog.view';
export const HOME_VIEW = 'home.view';
